import { memo, type ReactNode } from 'react';

import { type AgentSessionResponse } from '@air/server-sdk';

import { formatWorkspaceAgentSessionRowTimestamp } from '~/components/v2/components/workspace/workspace-agent-panel/utils/formatWorkspaceAgentSessionRow';

export type WorkspaceAgentPanelMyTasksRowMetaContainerProps = {
  children: ReactNode;
};

export const WorkspaceAgentPanelMyTasksRowMetaContainer = memo(
  ({ children }: WorkspaceAgentPanelMyTasksRowMetaContainerProps) => {
    return (
      <div className="flex min-h-4 items-center gap-1 overflow-hidden whitespace-nowrap pl-7 ads:text-metadata text-10 text-gray-8 leading-4">
        {children}
      </div>
    );
  },
);

WorkspaceAgentPanelMyTasksRowMetaContainer.displayName = 'WorkspaceAgentPanelMyTasksRowMetaContainer';

export type WorkspaceAgentPanelMyTasksRowMetaProps = {
  createdByName: string | undefined;
  session: AgentSessionResponse;
};

export const WorkspaceAgentPanelMyTasksRowMeta = memo(
  ({ createdByName, session }: WorkspaceAgentPanelMyTasksRowMetaProps) => {
    return (
      <WorkspaceAgentPanelMyTasksRowMetaContainer>
        {createdByName ? (
          <>
            <span className="min-w-0 truncate">{createdByName}</span>
            <span aria-hidden className="px-px font-medium ads:text-metadata text-gray-8">
              ·
            </span>
          </>
        ) : null}
        <span className="shrink-0 tabular-nums first-letter:uppercase">
          {formatWorkspaceAgentSessionRowTimestamp(session.updatedAt)}
        </span>
      </WorkspaceAgentPanelMyTasksRowMetaContainer>
    );
  },
);

WorkspaceAgentPanelMyTasksRowMeta.displayName = 'WorkspaceAgentPanelMyTasksRowMeta';
